// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfitChartCustomTooltip_wrapper__OtMrY"};